export default __webpack_public_path__ + "static/media/iread11.5b1ed28e.jpeg";